import { render, staticRenderFns } from "./r-ship-kind.vue?vue&type=template&id=122c8a44"
import script from "./r-ship-kind.vue?vue&type=script&lang=js"
export * from "./r-ship-kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122c8a44')) {
      api.createRecord('122c8a44', component.options)
    } else {
      api.reload('122c8a44', component.options)
    }
    module.hot.accept("./r-ship-kind.vue?vue&type=template&id=122c8a44", function () {
      api.rerender('122c8a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-ship-kind.vue"
export default component.exports